import React, { useState } from 'react';
import { motion } from 'motion/react';
import { ArrowRight, Loader2 } from 'lucide-react';

/**
 * Text-reveal join button (Amicro-style micro-interaction).
 * Paste-adapted — no Amicro package required.
 */
function TextRevealButton({
  children = 'Join',
  onClick,
  disabled = false,
  loading = false,
  type = 'button',
  style = {},
  className = ''
}) {
  const [isHovered, setIsHovered] = useState(false);
  const showHover = isHovered && !disabled && !loading;
  const label = typeof children === 'string' ? children : 'Join';

  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      whileHover={disabled || loading ? undefined : { scale: 1.02 }}
      whileTap={disabled || loading ? undefined : { scale: 0.96 }}
      className={className}
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        width: '100%',
        minHeight: 48,
        padding: '0.85rem 1.5rem',
        border: 'none',
        borderRadius: 12,
        color: 'white',
        fontSize: '1rem',
        fontWeight: 700,
        fontFamily: "'Orbitron', sans-serif",
        background: 'linear-gradient(120deg, #D702F6 0%, #8C2BFF 100%)',
        boxShadow: '0 8px 24px rgba(215, 2, 246, 0.4)',
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        opacity: disabled || loading ? 0.5 : 1,
        transition: 'opacity 0.2s ease',
        ...style
      }}
    >
      {loading ? (
        <Loader2 size={18} className="spin" />
      ) : (
        <>
          <div
            style={{
              position: 'relative',
              width: 18,
              height: 18,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            <motion.div
              animate={{ rotate: showHover ? 45 : 0 }}
              transition={{ type: 'spring', stiffness: 400, damping: 25 }}
              style={{ display: 'flex' }}
            >
              <ArrowRight size={18} />
            </motion.div>
          </div>
          <div style={{ position: 'relative', height: 20, overflow: 'hidden' }}>
            <motion.div
              animate={{ y: showHover ? -20 : 0 }}
              transition={{ type: 'spring', stiffness: 400, damping: 25 }}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <span
                style={{
                  display: 'block',
                  height: 20,
                  lineHeight: '20px',
                  whiteSpace: 'nowrap'
                }}
              >
                {label}
              </span>
              <span
                style={{
                  display: 'block',
                  height: 20,
                  lineHeight: '20px',
                  whiteSpace: 'nowrap'
                }}
              >
                {label}
              </span>
            </motion.div>
          </div>
        </>
      )}
    </motion.button>
  );
}

export default TextRevealButton;
